import { theme as aiduTheme } from './aidu/index.js';
import { theme as inviaTheme } from './invia/index.js';
import { theme as reisegeierTheme } from './reisegeier/index.js';
import { theme as reisenTheme } from './reisen/index.js';
import { theme as reisenFluegeTheme } from './reisenFluege/index.js';
import { theme as travelplanetTheme } from './travelplanet/index.js';
export const themeTokens = {
  'aidu-at': aiduTheme,
  'aidu-ch': aiduTheme,
  'aidu-de': aiduTheme,
  'invia-cz': inviaTheme,
  'invia-hu': inviaTheme,
  'invia-sk': inviaTheme,
  'travelplanet-pl': travelplanetTheme,
  'reisegeier-at': reisegeierTheme,
  'reisegeier-ch': reisegeierTheme,
  'reisegeier-de': reisegeierTheme,
  'reisen-de': reisenTheme,
  'reisen-fluege-de': reisenFluegeTheme
};